import { FC, useContext, useEffect } from "react";
import { AppContext } from "src/api/AppContext";
import ClubRouter from "./ClubRouter";
import ClientRouter from "./ClientRouter";
import { UserRole, useDeleteShoppingCartMutation } from "src/generated/graphql";
import AppShell from "../modules/AppShell";
import { HeaderContentProvider } from "src/api/context/HeaderContext";
import ClientAppShell from "src/screens/ClientAppShell";
import { ShoppingCartMethods } from "src/utils/constants";
import { useLoaderOverlay } from "src/api/context/LoaderOverlayContext ";

const Router: FC = () => {
  const { currentUser } = useContext(AppContext);
  const { LoaderOverlay } = useLoaderOverlay();
  const [deleteShoppingCart] = useDeleteShoppingCartMutation();

  useEffect(() => {
    const _shoppingCartId = ShoppingCartMethods.get();
    if (_shoppingCartId !== null) {
      deleteShoppingCart({
        variables: {
          id: _shoppingCartId!,
        },
      });
    }
    return () => {
      sessionStorage.clear();
    };
  }, []);
  return (
    <>
      <LoaderOverlay />
      {currentUser?.role == UserRole.Client ? (
        <HeaderContentProvider>
          <ClientAppShell>
            <ClientRouter />
          </ClientAppShell>
        </HeaderContentProvider>
      ) : (
        <AppShell>
          <ClubRouter />
        </AppShell>
      )}
    </>
  );
};

export default Router;
